// 老的浏览器可能根本没有实现 mediaDevices，所以我们可以先设置一个空的对象
if (navigator.mediaDevices === undefined) {
    navigator.mediaDevices = {};
}

// 一些浏览器部分支持 mediaDevices。我们不能直接给对象设置 getUserMedia
// 因为这样可能会覆盖已有的属性。这里我们只会在没有getUserMedia属性的时候添加它。
if (navigator.mediaDevices.getUserMedia === undefined) {
    let getUserMedia =
        navigator.getUserMedia ||
        navigator.webkitGetUserMedia ||
        navigator.mozGetUserMedia ||
        navigator.msGetUserMedia;
    navigator.mediaDevices.getUserMedia = function (constraints) {
        // 首先，如果有getUserMedia的话，就获得它

        // 一些浏览器根本没实现它 - 那么就返回一个error到promise的reject来保持一个统一的接口
        if (!getUserMedia) {
            return Promise.reject(new Error('getUserMedia is not implemented in this browser'));
        }

        // 否则，为老的navigator.getUserMedia方法包裹一个Promise
        return new Promise(function (resolve, reject) {
            getUserMedia.call(navigator, constraints, resolve, reject);
        });
    }
}

//wav 能指定sampleBits和sampleRate
//mp3 不能指定sampleBits和sampleRate
let HZRecorder = function (stream, config) {
    config = config || {};
    config.format     = config.format || 'wav';
    config.sampleBits = config.sampleBits || 8;      //采样数位 8, 16
    config.sampleRate = config.sampleRate || (44100 / 6);   //采样率(1/6 44100)
    config.bitRate    = config.bitRate || 128;
    
    // 音量阈值控制配置
    config.volumeThreshold = config.volumeThreshold || 0.01; // 音量阈值
    config.volumeDetectionEnabled = config.volumeDetectionEnabled !== false; // 默认启用
    config.volumeSmoothingFactor = config.volumeSmoothingFactor || 0.8; // 平滑因子

    console.log('HZRecorder.config', config);


    //创建一个音频环境对象
    let audioContext = window.AudioContext || window.webkitAudioContext;
    let context = new audioContext();
    console.log('HZRecorder.context', context);

    //将声音输入这个对像
    let audioInput = context.createMediaStreamSource(stream);

    //设置音量节点
    let volume = context.createGain();
    audioInput.connect(volume);

    //创建缓存，用来缓存声音
    let bufferSize = 4096;

    // 创建声音的缓存节点，createScriptProcessor方法的
    // 第二个和第三个参数指的是输入和输出都是双声道。
    let recorder = context.createScriptProcessor(bufferSize, 2, 2);

    let audioData = {
        outputFormat: config.format || 'wav',
        samplesMono: null,
        maxSamples: 1152,
        // eslint-disable-next-line no-undef
        mp3Encoder: new lamejs.Mp3Encoder(1, context.sampleRate || 44100, config.bitRate || 128),
        dataBuffer: [],
        size: 0, // 录音文件长度
        buffer: [], // 录音缓存
        inputSampleRate: context.sampleRate, // 输入采样率
        inputSampleBits: 16, // 输入采样数位 8, 16
        outputSampleRate: config.sampleRate, // 输出采样率
        outputSampleBits: config.sampleBits, // 输出采样数位 8, 16
        
        // 音量检测相关变量
        volumeThreshold: config.volumeThreshold,
        volumeDetectionEnabled: config.volumeDetectionEnabled,
        volumeSmoothingFactor: config.volumeSmoothingFactor,
        currentVolume: 0, // 当前音量
        smoothedVolume: 0, // 平滑后的音量

        convertBuffer: function(arrayBuffer) {
            let data = new Float32Array(arrayBuffer);
            let out = new Int16Array(arrayBuffer.length);
            this.floatTo16BitPCM(data, out);
            return out;
        },
        floatTo16BitPCM: function(input, output) {
            for (let i = 0; i < input.length; i++) {
                let s = Math.max(-1, Math.min(1, input[i]));
                output[i] = s < 0 ? s * 0x8000 : s * 0x7fff;
            }
        },
        appendToBuffer: function(mp3Buf) {
            this.dataBuffer.push(new Int8Array(mp3Buf));
        },
        inputMP3: function(arrayBuffer) {
            this.samplesMono = this.convertBuffer(arrayBuffer);
            let remaining = this.samplesMono.length;
            for (let i = 0; remaining >= 0; i += this.maxSamples) {
                let left = this.samplesMono.subarray(i, i + this.maxSamples);
                let mp3buf = this.mp3Encoder.encodeBuffer(left);
                this.appendToBuffer(mp3buf);
                remaining -= this.maxSamples;
            }
        },
        finishMP3: function() {
            this.appendToBuffer(this.mp3Encoder.flush());
            return new Blob(this.dataBuffer, { type: 'audio/mp3' });
        },

        inputWAV: function(data) {
            this.buffer.push(new Float32Array(data));
            this.size += data.length;
        },
        compress: function() {
            let data = new Float32Array(this.size);
            let offset = 0;
            for (let i = 0; i < this.buffer.length; i++) {
                data.set(this.buffer[i], offset);
                offset += this.buffer[i].length;
            }
            let ratio = this.inputSampleRate / this.outputSampleRate;
            let compression = Math.max(1, Math.round(ratio));
            let length = Math.floor(data.length / compression);
            let result = new Float32Array(length);
            let index = 0;
            let j = 0;
            while (index < length) {
                result[index] = data[j];
                j += compression;
                index++;
            }
            this.actualOutputSampleRate = Math.floor(this.inputSampleRate / compression);
            return result;
        },
        finishWAV: function() {
            let sampleRate = this.actualOutputSampleRate || this.outputSampleRate;
            let sampleBits = Math.min(this.inputSampleBits, this.outputSampleBits);
            let bytes = this.compress();

            let dataLength = bytes.length * (sampleBits / 8);
            let buffer = new ArrayBuffer(44 + dataLength);
            let data = new DataView(buffer);

            let channelCount = 1; // 单声道
            let offset = 0;

            let writeString = function(str) {
                for (let i = 0; i < str.length; i++) {
                    data.setUint8(offset + i, str.charCodeAt(i));
                }
            };

            // 资源交换文件标识符
            writeString('RIFF');
            offset += 4;
            // 下个地址开始到文件尾总字节数,即文件大小-8
            data.setUint32(offset, 36 + dataLength, true);
            offset += 4;
            // WAV文件标志
            writeString('WAVE');
            offset += 4;
            // 波形格式标志
            writeString('fmt ');
            offset += 4;
            // 过滤字节,一般为 0x10 = 16
            data.setUint32(offset, 16, true);
            offset += 4;
            // 格式类别 (PCM形式采样数据)
            data.setUint16(offset, 1, true);
            offset += 2;
            // 通道数
            data.setUint16(offset, channelCount, true);
            offset += 2;
            // 采样率,每秒样本数,表示每个通道的播放速度
            data.setUint32(offset, sampleRate, true);
            offset += 4;
            // 波形数据传输率 (每秒平均字节数) 单声道×每秒数据位数×每样本数据位/8
            data.setUint32(offset, channelCount * sampleRate * (sampleBits / 8), true);
            offset += 4;
            // 快数据调整数 采样一次占用字节数 单声道×每样本的数据位数/8
            data.setUint16(offset, channelCount * (sampleBits / 8), true);
            offset += 2;
            // 每样本数据位数
            data.setUint16(offset, sampleBits, true);
            offset += 2;
            // 数据标识符
            writeString('data');
            offset += 4;
            // 采样数据总数,即数据总大小-44
            data.setUint32(offset, dataLength, true);
            offset += 4;
            // 写入采样数据
            if (sampleBits === 8) {
                for (let i = 0; i < bytes.length; i++, offset++) {
                    const s = Math.max(-1, Math.min(1, bytes[i]));
                    let val = s < 0 ? s * 0x8000 : s * 0x7fff;
                    val = parseInt(255 / (65535 / (val + 32768)), 10);
                    data.setInt8(offset, val, true);
                }
            } else {
                for (let i = 0; i < bytes.length; i++, offset += 2) {
                    const s = Math.max(-1, Math.min(1, bytes[i]));
                    data.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7fff, true);
                }
            }

            return new Blob([data], { type: 'audio/wav' });
        },

        inputOrigData: function (data) {
            switch(this.outputFormat) {
                case 'wav': this.inputWAV(data); break;
                case 'mp3': this.inputMP3(data); break;
                default: break;
            }
        },
        clearBuffer: function() {
            this.dataBuffer = [];
            this.buffer = [];
            this.size = 0;
        },
        
        // 计算音频数据的音量（RMS值）
        calculateVolume: function(data) {
            let sum = 0;
            for (let i = 0; i < data.length; i++) {
                sum += data[i] * data[i];
            }
            return Math.sqrt(sum / data.length);
        },
        
        // 将线性音量值转换为dBFS
        linearToDbfs: function(linearValue) {
            if (linearValue <= 0) return -Infinity;
            return 20 * Math.log10(linearValue);
        },
        
        // 将dBFS值转换为线性音量值
        dbfsToLinear: function(dbfsValue) {
            if (dbfsValue === -Infinity) return 0;
            return Math.pow(10, dbfsValue / 20);
        },
        
        // 检查音量是否超过阈值
        shouldRecordAudio: function(data) {
            if (!this.volumeDetectionEnabled) {
                return true; // 如果未启用音量检测，直接录制
            }
            
            // 计算当前音量
            this.currentVolume = this.calculateVolume(data);
            
            // 应用平滑因子
            this.smoothedVolume = this.smoothedVolume * this.volumeSmoothingFactor + 
                                 this.currentVolume * (1 - this.volumeSmoothingFactor);
            
            // 调试信息：显示当前音量的dBFS值（可选，用于调试）
            if (Math.random() < 0.01) { // 1%的概率输出调试信息，避免日志过多
                const currentDbfs = this.linearToDbfs(this.smoothedVolume);
                const thresholdDbfs = this.linearToDbfs(this.volumeThreshold);
                console.log(`音量检测 - 当前: ${currentDbfs.toFixed(1)} dBFS, 阈值: ${thresholdDbfs.toFixed(1)} dBFS`);
            }
            
            // 判断是否超过阈值
            return this.smoothedVolume > this.volumeThreshold;
        }
    };

    //开始录音
    this.start = function () {
        audioInput.connect(recorder);
        recorder.connect(context.destination);
    };

    //停止录音节点（断开录音处理器，不释放流）
    this.stop = function () {
        recorder.disconnect();
    };

    // 停止所有麦克风轨道（释放硬件麦克风占用）
    // iOS 上必须在 restoreAudioOutput 之前调用，否则系统不会切回扬声器
    this.stopStream = function () {
        try {
            stream.getTracks().forEach(function(track) {
                track.stop();
            });
        } catch(e) {
            console.warn('HZRecorder.stopStream error', e);
        }
    };

    // 结束
    this.end = function() {
        try { context.close(); } catch(e) {}
    };

    // 继续
    this.again = function() {
        recorder.connect(context.destination);
    };

    //获取音频文件
    this.getMp3Blob = function () {
        this.stop();
        let blob= audioData.finishMP3();
        audioData.clearBuffer();
        return blob;
    };
    this.getWavBlob = function () {
        this.stop();
        let blob = audioData.finishWAV();
        audioData.clearBuffer();
        return blob;
    };

    //音频采集
    recorder.onaudioprocess = function (e) {
        let inputData = e.inputBuffer.getChannelData(0);
        
        // 应用音量阈值过滤
        if (audioData.shouldRecordAudio(inputData)) {
            audioData.inputOrigData(inputData);
        }
        // 如果音量低于阈值，则不处理音频数据（相当于过滤掉杂音）
    };

};

//抛出异常
HZRecorder.throwError = function (message) {
    throw new function () { this.toString = function () { return message; };};
};
//是否支持录音
HZRecorder.canRecording = (navigator.getUserMedia != null);
//获取录音机
    HZRecorder.get = function (callback, config) {
        if (callback) {
            // 回滚：移除之前的 Audio Session Hack，因为它可能导致初始静音
            // navigator.audioSession 操作移回业务层控制

            navigator.mediaDevices
                .getUserMedia({ audio: true })
                .then(function(stream) {
                    // 回滚：移除这里的 audioSession 设置
                    let rec = new HZRecorder(stream, config);
                    callback(rec);
                })
                .catch(function(error) {
                console.log('无法录音，请检查设备状态', error);
                HZRecorder.throwError('无法录音，请检查设备状态');
            });
    }
};
window.HZRecorder = HZRecorder;
